import PackageJSON from '../package.json';

export const AppVersion = PackageJSON.version;
if (!AppVersion) {
  throw new Error("Did not detect a version in the 'package.json' file!");
}

export const AppName = PackageJSON.name;
if (!AppName) {
  throw new Error("Did not detect a name in the 'package.json' file!");
}
